module.exports = __webpack_public_path__ + "static/media/fitazfk-wordmark.79aeb49d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fitazfk-wordmark.png
// module id = 795
// module chunks = 0